import { useState, useEffect } from 'react';
import { IPost } from 'client/models/IPost';
import { useDispatch, useSelector } from 'react-redux';
import { deletePostById } from 'client/_redux/actions/post';
import { getAllCategoryTours } from 'client/_redux/actions/categoryTour';
import { RootState } from 'client/_redux/reducers';
import { withConfirmation } from 'client/helpers/withConfirmation';
import { useTranslation } from 'react-i18next';
import { videoSpecOptions } from 'client/constants/videoSpecOptions';
import { ISelectorOption } from 'types/ISelectorOption';

export const useVideoCardInfo = (post: IPost) => {
  const [t] = useTranslation();

  const [videoCard, setvideoCard] = useState<boolean>(false);
  const { videoTypeOptions } = videoSpecOptions(t);

  const dispatch = useDispatch();

  const allCategoryTours = useSelector(
    (state: RootState) => state.categoryTour.allCategoryTours,
  );

  useEffect(() => {
    dispatch(getAllCategoryTours());
  }, [dispatch]);

  const parcourTypeOptions: ISelectorOption<string>[] = (
    allCategoryTours?.categoryTours || []
  ).map((cat) => ({
    label: cat.name,
    value: cat._id,
  }));

  const changeButton = () => {
    setvideoCard(!videoCard);
  };

  const handleDelete = () => {
    withConfirmation(() => {
      dispatch(post?._id && deletePostById(post?._id));
    });
  };

  return {
    videoCard,
    changeButton,
    handleDelete,
    parcourTypeOptions,
    videoTypeOptions,
  };
};
